const API_BASE_URL = process.env.REACT_APP_API_ADDRESS;

// === Get user via DLL ID (admin only) ===
export const getUserViaDllId = async (dll_id) => {
  try {
    const url = `${API_BASE_URL}/accounts/users/get_user_via_dll_id/`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
      },
      body: JSON.stringify({ dll_id }),
    });

    const data = await response.json();
    return {
      success: response.ok,
      data: response.ok ? data : null,
      error: response.ok ? null : data.error || data.detail,
      statusCode: response.status,
    };
  } catch (error) {
    console.error('getUserViaDllId error', error);
    return { success: false, data: null, error: error.message, statusCode: 500 };
  }
};

export const login = async (username, password, gatewayJwt, clientSignals, code) => {
    try {
        const url = new URL(`${API_BASE_URL}/accounts/token/`);
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username, password, gateway_jwt: gatewayJwt, client: clientSignals, code: code || '' }),
        });

        const data = await response.json();
        if (response.ok) {
            localStorage.setItem('access_token', data.access); // Store access token
            localStorage.setItem('refresh_token', data.refresh); // Store refresh token
        }
        return {
            success: response.ok,
            data: response.ok ? data : null,
            error: response.ok ? null : data.detail,
            statusCode: response.status
        };
    } catch (error) {
        console.error('Login error', error);
        return {
            success: false,
            data: null,
            statusCode: 500,
            error: error.message
        };
    }
};

export const logout = async () => {
    try {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        return {
            success: true,
            data: { message: 'Logged out successfully' },
            statusCode: 200
        };
    } catch (error) {
        console.error('Logout error', error);
        return {
            success: false,
            data: null,
            statusCode: 500,
            error: error.message
        };
    }
};

export const userInfo = async () => {
    try {
        const url = new URL(`${API_BASE_URL}/accounts/users/user_info/`);
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            },
        });

        const data = await response.json();
        return {
            success: response.ok,
            data: response.ok ? data : null,
            statusCode: response.status
        };
    } catch (error) {
        console.error('User info error', error);
        return {
            success: false,
            data: null,
            statusCode: 500,
            error: error.message
        };
    }
};

export const fetchAllUsers = async () => {
    try {
        const url = new URL(`${API_BASE_URL}/accounts/users/combined_users/`);
        // const url = new URL(`${API_BASE_URL}/api/dashboard-data/`);
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            },
        });

        const data = await response.json();
        return {
            success: response.ok,
            data: response.ok ? data : null,
            statusCode: response.status,
            error: response.ok ? null : data.detail,
        };
    } catch (error) {
        console.error('Fetch all users error', error);
        return {
            success: false,
            data: null,
            statusCode: 500,
            error: error.message,
        };
    }
};

export const fetchAllDbUsers = async () => {
    try {
        const url = new URL(`${API_BASE_URL}/accounts/users/list_db_users/`);
        // const url = new URL(`${API_BASE_URL}/api/dashboard-data/`);
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            },
        });

        const data = await response.json();
        return {
            success: response.ok,
            data: response.ok ? data : null,
            statusCode: response.status,
            error: response.ok ? null : data.detail,
        };
    } catch (error) {
        console.error('Fetch all users error', error);
        return {
            success: false,
            data: null,
            statusCode: 500,
            error: error.message,
        };
    }
};

export const createUserLegacy = async ({username, email, password, first_name, last_name, is_active = true, phone_number = null, dll_id = null, ad_object_guid = null}) => {
    try {
        const url = new URL(`${API_BASE_URL}/accounts/users/register/`);
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            },
            body: JSON.stringify({ 
                username, 
                email, 
                password, 
                password2: password, // Confirm password
                first_name, 
                last_name,
                is_active,
                phone_number,
                dll_id,
                ad_object_guid
            }),
        });

        const data = await response.json();
        return {
            success: response.ok,
            data: response.ok ? data : null,
            errors: !response.ok ? data : null,
            statusCode: response.status,
        };
    } catch (error) {
        console.error('Create user error', error);
        return {
            success: false,
            data: null,
            statusCode: 500,
            error: error.message,
        };
    }
};

export const changePasswordLegacy = async (passwordData, userId) => {
    const url = `${API_BASE_URL}/accounts/users/${userId}/change_password/`;
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            },
            body: JSON.stringify(passwordData),
        });

        const data = await response.json();
        return {
            success: response.ok,
            data: response.ok ? data : null,
            errors: !response.ok ? data : null,
            statusCode: response.status,
        };
    } catch (error) {
        console.error('Change password error', error);
        return {
            success: false,
            data: null,
            statusCode: 500,
            error: error.message,
        };
    }
};

export const updateProfileLegacy = async (profileData, userId) => {
    const url = `${API_BASE_URL}/accounts/users/${userId}/change_profile/`;
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            },
            body: JSON.stringify(profileData),
        });

        const data = await response.json();
        return {
            success: response.ok,
            data: response.ok ? data : null,
            errors: !response.ok ? data : null,
            statusCode: response.status,
        };
    } catch (error) {
        console.error('Update profile error', error);
        return {
            success: false,
            data: null,
            statusCode: 500,
            error: error.message,
        };
    }
};

export const deleteUserLegacy = async (userId) => {
    const url = `${API_BASE_URL}/accounts/users/${userId}/delete_profile/`;
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            },
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data.detail || 'Error deleting profile');
        }

        // Clear tokens on successful deletion
        // localStorage.removeItem('access_token');
        // localStorage.removeItem('refresh_token');

        return { success: true };
    } catch (error) {
        console.error('Delete profile error', error);
        return {
            success: false,
            error: error.message,
        };
    }
};

// =======================
// 🧾 User Management
// =======================

export const createUser = async (data) => {
    try {
        const url = new URL(`${API_BASE_URL}/accounts/user-profiles/`);
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            },
            body: JSON.stringify(data),
        });

        const result = await response.json();
        return {
            success: response.ok,
            data: response.ok ? result : null,
            error: response.ok ? null : result?.detail || result,
            statusCode: response.status,
        };
    } catch (error) {
        console.error('Create user error', error);
        return {
            success: false,
            data: null,
            statusCode: 500,
            error: error.message,
        };
    }
};

export const updateUser = async (id, data) => {
    try {
        const url = new URL(`${API_BASE_URL}/accounts/user-profiles/${id}/`);
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            },
            body: JSON.stringify(data),
        });

        const result = await response.json();
        return {
            success: response.ok,
            data: response.ok ? result : null,
            error: response.ok ? null : result?.detail || result,
            statusCode: response.status,
        };
    } catch (error) {
        console.error('Update user error', error);
        return {
            success: false,
            data: null,
            statusCode: 500,
            error: error.message,
        };
    }
};

export const deleteUser = async (id) => {
    try {
        const url = new URL(`${API_BASE_URL}/accounts/user-profiles/${id}/`);
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            },
        });

        return {
            success: response.ok,
            data: response.ok ? { message: 'User deleted' } : null,
            error: response.ok ? null : 'Failed to delete user',
            statusCode: response.status,
        };
    } catch (error) {
        console.error('Delete user error', error);
        return {
            success: false,
            data: null,
            statusCode: 500,
            error: error.message,
        };
    }
};

/**
 * List all user profiles for the current tenant (auth required).
 * GET /accounts/user-profiles/
 * Optional: pass query params (e.g. { tenant_id, search, ordering, page, page_size }).
 */
export const listTenantUsers = async (params = {}) => {
    try {
        const url = new URL(`${API_BASE_URL}/accounts/user-profiles/`);
        Object.entries(params).forEach(([k, v]) => {
            if (v !== undefined && v !== null && v !== "") url.searchParams.append(k, v);
        });

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            },
        });

        const data = await response.json();

        return {
            success: response.ok,
            data: response.ok ? data : null,
            error: response.ok ? null : data?.detail || data,
            statusCode: response.status,
        };
    } catch (error) {
        console.error('List users error', error);
        return {
            success: false,
            data: null,
            statusCode: 500,
            error: error.message,
        };
    }
};